import { Controller } from 'stimulus';

const TomSelect = require('../lib/tom_select');

// The picker for a job field's options (docs/UI_STYLE_GUIDE.md "Option
// pickers"), the same Tom Select box as the Tags and people pickers:
//
// - Multi-select: chips. Type to find an option, Enter to add it, x or
//   Backspace to remove. The <select multiple> has no name; the choices go
//   into the hidden value input as "A, B" in the options' order, the way the
//   field is stored.
// - A long Dropdown: one choice with search. The <select> itself submits.
export default class extends Controller {
  static targets = ['select', 'value'];

  connect() {
    if (this.tomSelect) return;

    const select = this.selectTarget;
    // Tom Select moves picked <option>s into the order they were picked, so
    // keep the options' own order for writing the value.
    this.order = Array.from(select.options).map((option) => option.value);
    const plugins = [];
    if (select.multiple) plugins.push('remove_button');
    else if (!select.required) plugins.push('clear_button');

    this.tomSelect = new TomSelect(select, {
      plugins,
      create: false,
      maxOptions: null,
      // Filter as each key is typed: with Tom Select's default 300ms wait,
      // typing "sae" and pressing Enter quickly picked the first option.
      refreshThrottle: 0,
      closeAfterSelect: !select.multiple,
      placeholder: select.dataset.placeholder,
      onItemAdd: () => {
        if (!select.multiple) return;
        this.tomSelect.setTextboxValue('');
        this.tomSelect.refreshOptions(false);
      },
    });
    this.tomSelect.on('change', () => this.write());
  }

  // Dragging a card or row (the template builder, the job form's field list)
  // disconnects and reconnects it, and destroy() puts the <select> back the
  // way the page rendered it. Keep what's picked now, so the picker that
  // reconnects (and a Dropdown's submitted value) starts from it.
  disconnect() {
    if (!this.tomSelect) return;

    const picked = new Set([].concat(this.tomSelect.getValue()));
    this.tomSelect.destroy();
    this.tomSelect = null;
    Array.from(this.selectTarget.options).forEach((option) => {
      const on = picked.has(option.value);
      option.selected = on; // eslint-disable-line no-param-reassign
      option.toggleAttribute('selected', on);
    });
  }

  write() {
    if (!this.hasValueTarget) return;

    const picked = new Set([].concat(this.tomSelect.getValue()));
    const values = this.order.filter((value) => picked.has(value));
    this.valueTarget.value = values.join(', ');
    this.valueTarget.dispatchEvent(new Event('input', { bubbles: true }));
    this.valueTarget.dispatchEvent(new Event('change', { bubbles: true }));
  }
}
